import React, { useState } from "react";
import Uppy from "@uppy/core";
import { Dashboard } from "@uppy/react";
import XHRUpload from "@uppy/xhr-upload";
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import toast, { Toaster } from "react-hot-toast";

const CertificateUpload = ({ uploadCertificateUrl }) => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState("");
  const [fileName, setFileName] = useState("");

  const uppy = new Uppy({
    meta: { type: "certificate" },
    restrictions: {
      maxNumberOfFiles: 1,
      maxFileSize: 5242880,
      allowedFileTypes: [".pdf", ".doc", ".docx", "image/*"],
    },
    autoProceed: true,
  });

  uppy.use(XHRUpload, {
    endpoint: `https://register.ugonsa.org/v1/api/upload/certificate`,
    method: "post",
    formData: true,
    fieldName: "certificate",
  });

  uppy.on("upload-error", (file, error, response) => {
    console.error("Upload error:", error, response);
    toast.error("Upload failed: " + (error.message || "Unknown error"));
    setUploadStatus("failed");
  });

  uppy.on("file-added", (file) => {
    setFileName(file.name);
    setUploadStatus("uploading");
  });

  uppy.on("upload-progress", (file, progress) => {
    const progressValue = Math.round(
      (progress.bytesUploaded / progress.bytesTotal) * 100
    );
    setUploadProgress(progressValue);
  });

  uppy.on("complete", (result) => {
    if (!result.successful || !result.successful[0]?.response?.body?.success) {
      setUploadStatus("failed");
      return toast.error("Upload failed. Please try again.");
    }

    setUploadStatus("success");
    toast.success("Certificate uploaded successfully!");
    uploadCertificateUrl(result.successful[0].response.body.data.secure_url);
  });

  return (
    <>
      <Dashboard uppy={uppy} height={250} width="100%" />

      {uploadStatus && (
        <div className="mt-3">
          {uploadStatus === "uploading" && (
            <div className="alert alert-info d-flex align-items-center">
              <div
                className="spinner-border spinner-border-sm me-2"
                role="status"
              >
                <span className="visually-hidden">Uploading...</span>
              </div>
              <div>
                Uploading {fileName}: {uploadProgress}%
              </div>
            </div>
          )}

          {uploadStatus === "success" && (
            <div className="alert alert-success d-flex align-items-center">
              <i className="mdi mdi-check-circle me-2"></i>
              <div>Certificate uploaded successfully! ({fileName})</div>
            </div>
          )}

          {uploadStatus === "failed" && (
            <div className="alert alert-danger d-flex align-items-center">
              <i className="mdi mdi-alert-circle me-2"></i>
              <div>Upload failed. Please try again.</div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default CertificateUpload;
